type FaceCountPriceRateType = {
  face_count: number;
  profit_rate: number;
};

export const FaceCountPriceRate = {
  getFaceCountPriceRate: (rows: FaceCountPriceRateType[], design_length: number) => {
    if (!design_length) return;
    if (!rows?.length) return;
    const row = rows.find((row) => {
      return row.face_count === design_length;
    });
    return row?.profit_rate;
  },
  useFaceCountPriceRate: (rows: FaceCountPriceRateType[]) => {
    return rows?.length;
  },
};
